export default __webpack_public_path__ + "static/media/SURE-background.89818abf.png";